import { Link } from "react-router-dom";
import { Command, ArrowLeft } from "lucide-react";
import { BrandFooter } from "@/components/uc/BrandFooter";

export const LegalLayout = ({ eyebrow, title, children, testId }) => (
  <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid={testId}>
    <header className="sticky top-0 z-30 bg-[#0A0A0A]/90 backdrop-blur-md border-b border-white/10">
      <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="legal-home-link">
          <div className="w-9 h-9 border border-amber-500/40 flex items-center justify-center bg-amber-500/5">
            <Command size={16} className="text-amber-400"/>
          </div>
          <div>
            <div className="font-mono-uc text-[9px] uppercase tracking-[0.3em] text-amber-400/80">THE SOVEREIGN UMBRELLA COMMAND</div>
            <div className="font-serif-display text-lg leading-tight">Command OS</div>
          </div>
        </Link>
        <Link to="/" className="flex items-center gap-1.5 font-mono-uc text-[10px] uppercase tracking-widest text-white/40 hover:text-amber-400 transition-colors">
          <ArrowLeft size={12}/> Back to Command
        </Link>
      </div>
    </header>
    <main className="max-w-4xl mx-auto px-6 py-12">
      <div className="uc-chip mb-3">{eyebrow}</div>
      <h1 className="font-serif-display text-4xl sm:text-5xl mb-10">{title}</h1>
      <div className="space-y-10 text-white/70 text-sm leading-relaxed">{children}</div>
      <BrandFooter />
    </main>
  </div>
);

export const LegalSection = ({ n, heading, children }) => (
  <section>
    <h2 className="font-mono-uc text-xs uppercase tracking-[0.25em] text-amber-400 mb-3">
      {n ? `${n} · ` : ""}{heading}
    </h2>
    <div className="space-y-3">{children}</div>
  </section>
);
